// src/components/CcpAdminDistricts/inc/AddDistrict.js
import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import useData from "../hooks/useData";
import useSchoolDropdown from "../hooks/useSchoolDropdown";
import SchoolsDropdownById from "./SchoolsDropDownById";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const AddDistrict = ({ onRefresh }) => {
  const [open, setOpen] = useState(false);
  const [district, setDistrict] = useState("");
  const [selectedSchool, setSelectedSchool] = useState(null); // Store the selected school object
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { data: schools, loading: schoolsLoading } = useSchoolDropdown();
  const { postData } = useData();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDistrict("");
    setSelectedSchool(null);
    setLoading(false);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleSubmit = async () => {
    if (!selectedSchool) {
      // Handle case where no school is selected (e.g., show an error message)
      return;
    }
    setLoading(true);
    try {
      await postData({
        district,
        school_name: selectedSchool.school_name, // Access from selectedSchool object
        school_id: selectedSchool.school_id, // Access from selectedSchool object
      });
      setSnackbarOpen(true);
      handleClose();
      if (onRefresh) {
        onRefresh(); // Call onRefresh to signal success and refresh
      }
    } catch (error) {
      console.error("Error adding district:", error);
      // Handle error, e.g., show an error message to the user
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="success"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}
        style={{ marginBottom: 16, marginTop: 10, marginRight: 16 }}
      >
        Add District
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <ModalDialogTitle onClose={handleClose}>
          Add New District
        </ModalDialogTitle>
        <DialogContent>
          <TextField
            label="District"
            fullWidth
            value={district}
            onChange={(e) => setDistrict(e.target.value)}
            margin="normal"
          />

          {schoolsLoading ? (
            <CircularProgress />
          ) : (
            <SchoolsDropdownById
              schools={schools}
              value={selectedSchool || { school_id: "" }} // Provide a default empty object
              onChange={setSelectedSchool}
            />
          )}
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} saveLabel="Submit" />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          District has been added
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddDistrict;
